import { useNavigation } from '@react-navigation/native';
import { ListItem, Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { CircleWrappedHslTicketImage } from 'components/services/ServicesDefault';
import React from 'react';
import { View } from 'react-native';
import { useHslStore } from 'stores/hslStore';
import styled from 'styled-components/native';
import { HslTicketContent } from 'types/generatedSchemaTypes';
import { ServicesNavProps } from 'types/navigation';
import { titleTypeText, validTimeText } from 'utils/hslUtils';

const IconWrapper = styled(View)`
  margin: 0px 14px;
`;

type HslTicketListItemProps = {
  ticket: HslTicketContent;
  index: number;
};

const HslTicketListItem = ({ ticket, index }: HslTicketListItemProps) => {
  const { navigate } = useNavigation<ServicesNavProps>();
  const handleTicketSelect = () => {
    useHslStore.getState().setSelectedHslTicket({
      ticketId: ticket.hslDetails.ticketId,
      ticketType: ticket.hslDetails.ticketType,
    });
    navigate('hslNavigator', { screen: 'hslTicketRenderView' });
  };

  return (
    <ListItem
      item={ticket}
      withBackground={theme.colors.white}
      title={titleTypeText(ticket.hslDetails.ticketType)}
      onPress={handleTicketSelect}
      testID={`hsl-ticket-item-${index}`}
      iconComponent={() => (
        <IconWrapper>
          <CircleWrappedHslTicketImage />
        </IconWrapper>
      )}
      indexValue={index}
      subtitleComponent={() => (
        <Meta color={theme.colors.gray300} testID={`hsl-ticket-valid-${index}`}>
          {validTimeText(ticket.hslDetails)}
        </Meta>
      )}
      arrowComponent={() => (
        <IconWrapper>
          <Icon name="Chevron_Right" size="s" />
        </IconWrapper>
      )}
    />
  );
};

export default HslTicketListItem;
